import { Box } from "@mui/system";
import { useTheme } from "@mui/system";
import useStyles from "./styles";
import {
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Tab,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Auditoria from "./registroAcoes";
import RegistroLogin from "./registroLogin";
import FilterBar from "../../../../components/topBarFilter";
import { Clear, FilterAltOutlined, Search } from "@mui/icons-material";
import Status from "../../status";
import ButtonTime from "../../../../components/buttonTime";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
export default function PainelDeLogs() {
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const styles = useStyles(theme);
  const [searchItem, setSearchItem] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [day, setDay] = useState(30);
  //filter time
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectTime, setSelectTime] = useState(5);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isValidRange, setIsValidRange] = useState(false);
  const [filterData, setFilterData] = useState({
    initialDate: dayjs()
      .subtract(6, "hours")
      .set("second", 0)
      .set("millisecond", 0)
      .toDate(),
    finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
  });

  useEffect(() => {
    const now = dayjs();
    setIsValidRange(
      dayjs.isDayjs(startDate) &&
        dayjs.isDayjs(endDate) &&
        startDate.isValid() &&
        endDate.isValid() &&
        !startDate.isAfter(endDate) &&
        !endDate.isBefore(startDate) &&
        !startDate.isAfter(now) &&
        !endDate.isAfter(now),
    );
  }, [endDate, startDate]);
  const actions = [
    {
      icon: <FilterAltOutlined />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
  ];
  //filter time
  const optionsTime = {
    0: {
      value: dayjs()
        .subtract(5, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 5 minutos",
    },
    1: {
      value: dayjs()
        .subtract(15, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 15 minutos",
    },
    2: {
      value: dayjs()
        .subtract(30, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 30 minutos",
    },
    3: {
      value: dayjs()
        .subtract(1, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Última hora",
    },
    4: {
      value: dayjs()
        .subtract(3, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 3 horas",
    },
    5: {
      value: dayjs()
        .subtract(6, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 6 horas",
    },
    6: {
      value: dayjs()
        .subtract(12, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 12 horas",
    },
    7: {
      value: dayjs()
        .subtract(24, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 24 horas",
    },
    8: {
      value: dayjs()
        .subtract(2, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 2 dias",
    },
    9: {
      value: dayjs()
        .subtract(7, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 7 dias",
    },
    10: {
      value: dayjs()
        .subtract(30, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 30 dias",
    },
    11: {
      value: dayjs()
        .subtract(90, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 90 dias",
    },
    12: {
      value: dayjs()
        .subtract(6, "month")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 6 meses",
    },
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleStartChange = (newValue) => {
    setStartDate(newValue);
    if (newValue?.isAfter(endDate)) {
      setEndDate(newValue);
    }
  };
  const handleEndChange = (newValue) => {
    setEndDate(newValue);
  };
  const handleAplicar = () => {
    setFilterData((prev) => ({
      ...prev,
      initialDate: dayjs(startDate).toDate(),
      finalDate: dayjs(endDate).toDate(),
    }));
    setSelectTime(null);
    handleClose();
  };
  const handleSelectTime = (key) => {
    setSelectTime(key);
    setStartDate(null);
    setEndDate(null);
    handleClose();

    setFilterData((prev) => ({
      ...prev,
      initialDate: optionsTime[key]?.value,
      finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
    }));
  };

  const selectorComponentLeft = (
    <TextField
      variant="outlined"
      label="Buscar"
      placeholder="Hora, Nome, etc..."
      value={searchItem}
      size="small"
      onChange={(event) => {
        setSearchItem(event.target.value);
      }}
      sx={styles.searchField}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
        endAdornment: searchItem ? (
          <InputAdornment position="end">
            <IconButton onClick={() => setSearchItem("")} edge="end">
              <Clear />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );

  return (
    <Box sx={styles.container}>
      {/**F I L T R O S */}
      {(value === 1 || value === 2) && (
        <FilterBar
          actions={actions}
          selectorComponentLeft={selectorComponentLeft}
          selectorComponentRight={
            <ButtonTime
              open={open}
              optionsTime={optionsTime}
              selectTime={selectTime}
              handleClick={handleClick}
              anchorEl={anchorEl}
              handleClose={handleClose}
              loading={loading}
              handleStartChange={handleStartChange}
              handleEndChange={handleEndChange}
              handleAplicar={handleAplicar}
              isValidRange={isValidRange}
              endDate={endDate}
              startDate={startDate}
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              setSelectTime={setSelectTime}
              handleSelectTime={handleSelectTime}
              filterData={filterData}
              DateTime={DateTimePicker}
            />
          }
          windowWidth={30000}
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          type={1}
        />
      )}
      {value === 0 && (
        <FilterBar
          actions={actions}
          selectorComponentLeft={
            <>
              <Box sx={{ width: "1px" }} />
            </>
          }
          windowWidth={30000}
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          type={1}
        />
      )}
      <Box sx={styles.contentContainer}>
        <TabContext value={value}>
          <TabList>
            <Tab
              label="Metricas do sistema"
              value={0}
              onClick={() => {
                setValue(0);
              }}
            />
            <Tab
              label="AÇÕES"
              value={1}
              onClick={() => {
                setValue(1);
              }}
            />
            <Tab
              label="ACESSOS"
              value={2}
              onClick={() => {
                setValue(2);
              }}
            />
          </TabList>
        </TabContext>
        {value === 0 && <Status day={day} setDay={setDay} />}
        {value === 1 && (
          <Auditoria
            searchItem={searchItem}
            setSearchItem={setSearchItem}
            filterData={filterData}
          />
        )}
        {value === 2 && (
          <RegistroLogin
            searchItem={searchItem}
            setSearchItem={setSearchItem}
            filterData={filterData}
          />
        )}
      </Box>
    </Box>
  );
}
